import { render, staticRenderFns } from "./warehousingOrderDetails.vue?vue&type=template&id=56bd1103&scoped=true&"
import script from "./warehousingOrderDetails.vue?vue&type=script&lang=js&"
export * from "./warehousingOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./warehousingOrderDetails.vue?vue&type=style&index=0&id=56bd1103&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd1103",
  null
  
)

export default component.exports